export enum SearchResultType {
  Account = 'account',
  Merchant = 'merchant',
  Goal = 'goal',
  Category = 'category',
}
